import React from 'react'

const ArrowDown: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 22 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.00016 0.333336L11.0002 8.33334L19.0002 0.333336L21.6668 3L11.0002 13.6667L0.333496 3L3.00016 0.333336Z"
        fill="#333333"
      />
    </svg>
  )
}

export default ArrowDown
